var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.open)?_c('div',{staticClass:"c-drawer"},[_c('div',{staticClass:"c-drawer__content"},[_vm._t("default")],2),_c('div',{staticClass:"c-drawer__backdrop"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }